import { render, staticRenderFns } from "./auxiliaryMaterialList.vue?vue&type=template&id=06b0e586&scoped=true"
import script from "./auxiliaryMaterialList.vue?vue&type=script&lang=js"
export * from "./auxiliaryMaterialList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b0e586",
  null
  
)

export default component.exports